import { Drawer } from '@ui';
import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import CreateTagForm from '@components/create-tag-form';
import { actions } from '@store/ducks/tags-page';
import TStore from 'types/store';
import { ModalState } from 'types/tags-page';

const TagDrawer: React.FC = () => {
  const dispatch = useDispatch();
  const drawerStatus = useSelector((state: TStore) => state.tagsPage.drawerStatus);
  const { formatMessage } = useIntl();

  return (
    <Drawer
      visible={drawerStatus === ModalState.opened}
      onClose={() => {
        dispatch(actions.setActiveTag(null));
        dispatch(actions.setModalStatus(ModalState.closed));
      }}
      title={formatMessage({ id: 'tags_table_title' })}
      destroyOnClose
    >
      <CreateTagForm />
    </Drawer>
  );
};

export default React.memo(TagDrawer);
